import React from "react";
import { Badge, Box, Button, Card, Icon, Text } from "~/components-shared";
import styled from "styled-components";
import Doughnut from "~/components-shared/Doughnut";
import { genericColor } from "~/lib/resolvers";
import { helpers } from "~/lib/helpers";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const List = styled.ul`
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.text.secondary;
}};
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  font-size: 12px;
`;
const Color = styled.i`
  background-color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColor(theme, $color);
}};
  width: 12px;
  height: 12px;
  margin-left: 5px;
  border-radius: 50%;
  display: inline-block;
`;
const CodeContributionsCard = _ref3 => {
  let {
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref3;
  const {
    current,
    previous
  } = widget.data;
  const deltaPercentage = previous.total === 0 ? 0 : (current.total - previous.total) / previous.total * 100;
  const currentTotal = current.prsCreated + current.prsReviewed + current.prComments + current.prsMerged + current.commitsPushed;
  const previousTotal = previous.prsCreated + previous.prsReviewed + previous.prComments + previous.prsMerged + previous.commitsPushed;
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 1
    }
  }, "Code Commit"), /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    align: "center"
  }, /*#__PURE__*/React.createElement(Doughnut, {
    size: 52,
    s: {
      mx: -5
    },
    contents: /*#__PURE__*/React.createElement(Box, {
      direction: "column",
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 9,
      lineHeight: 9,
      weight: "bold",
      color: "text",
      display: "block"
    }, current.total), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      align: "center",
      s: {
        mb: 1
      }
    }, currPeriod), /*#__PURE__*/React.createElement(Badge, {
      fontSize: 3.5,
      weight: "semiBold",
      color: deltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: deltaPercentage > 0 ? 0 : 180
    }), deltaPercentage.toFixed(0), "%"))
  }, /*#__PURE__*/React.createElement(Doughnut.Arc, {
    values: [current.commitsPushed / currentTotal * 100, current.prsCreated / currentTotal * 100, current.prComments / currentTotal * 100, current.prsReviewed / currentTotal * 100, current.prsMerged / currentTotal * 100],
    width: 5,
    colors: ["#9fadbc", "#85b8ff", "#A0D7E7", "#d293eb", "#7de2b8"],
    labels: [`${current.commitsPushed} Pushed commits (${currPeriod})`, `${current.prsCreated} PR's created (${currPeriod})`, `${current.prComments} PR's comments (${currPeriod})`, `${current.prsReviewed} PR's reviewed (${currPeriod})`, `${current.prsMerged} PR's merged (${currPeriod})`]
  }), /*#__PURE__*/React.createElement(Doughnut.Arc, {
    opacity: 0.4,
    values: [previous.commitsPushed / previousTotal * 100, previous.prsCreated / previousTotal * 100, previous.prComments / previousTotal * 100, previous.prsReviewed / previousTotal * 100, previous.prsMerged / previousTotal * 100],
    width: 5,
    scale: 0.83,
    colors: ["#9fadbc", "#85b8ff", "#A0D7E7", "#d293eb", "#7de2b8"],
    labels: [`${previous.commitsPushed} Pushed commits (${prevPeriod})`, `${previous.prsCreated} PR's created (${prevPeriod})`, `${previous.prComments} PR's comments (${prevPeriod})`, `${previous.prsReviewed} PR's reviewed (${prevPeriod})`, `${previous.prsMerged} PR's merged (${prevPeriod})`]
  })), /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Color, {
    $color: "#9fadbc"
  }), " Commits pushed"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Color, {
    $color: "#85b8ff"
  }), " PRs created"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Color, {
    $color: "#A0D7E7"
  }), " PR comments"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Color, {
    $color: "#d293eb"
  }), " PRs reviewed"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Color, {
    $color: "#7de2b8"
  }), " PRs merged"))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })));
};
export default CodeContributionsCard;